import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03e45031"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Builder Not Found", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Error", -1))
const _hoisted_7 = { class: "error-reason" }
const _hoisted_8 = { class: "modal-card-buttons" }
const _hoisted_9 = {
  key: 2,
  class: "content"
}
const _hoisted_10 = {
  key: 3,
  class: "content"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Account Created!", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "key" }, "Email:", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "key" }, "Password:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "modal-card-buttons" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 4,
  class: "content"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "g-input-wrapper" }
const _hoisted_21 = { class: "modal-card-buttons" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["SimpleModal"], {
    "click-to-close": $setup.canClickOff,
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (!$setup.selectedBuilder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
        : ($setup.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.error), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "g-button g-save",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, _toDisplayString($setup.countdownCounter > 0 ? $setup.countdownCounter : "Okay"), 1)
                ])
              ])
            ]))
          : ($setup.creatingAccount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("header", null, [
                  _createTextVNode("Creating Account"),
                  _createVNode($setup["DotDotDot"])
                ])
              ]))
            : ($setup.newAccountPassword)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("section", null, [
                    _createTextVNode("A new account has been created. Use the following details to access your account: "),
                    _createElementVNode("table", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_12,
                        _createElementVNode("td", _hoisted_13, _toDisplayString($setup.inputEmail), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_14,
                        _createElementVNode("td", _hoisted_15, _toDisplayString($setup.newAccountPassword), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "g-button g-save",
                        disabled: $setup.countdownCounter > 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                      }, _toDisplayString($setup.countdownCounter > 0 ? $setup.countdownCounter : "Confirm"), 9, _hoisted_17)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("header", null, "Give " + _toDisplayString($setup.selectedBuilder.name.firstName) + " Access", 1),
                  _createElementVNode("section", null, [
                    _createElementVNode("div", {
                      class: "info",
                      innerHTML: $setup.accessInfoText
                    }, null, 8, _hoisted_19),
                    _createElementVNode("form", {
                      onSubmit: _withModifiers($setup.submit, ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["g-input email", {invalid: $setup.emailValid}]),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.inputEmail) = $event)),
                          type: "email",
                          required: ""
                        }, null, 2), [
                          [_vModelText, $setup.inputEmail]
                        ]),
                        _createElementVNode("label", {
                          class: _normalizeClass(["g-label required", {'g-label-active': $setup.inputEmail.length > 0}]),
                          for: ".last-name"
                        }, "Enter Email Address", 2)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          class: "g-button g-borderless",
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
                        }, "Cancel"),
                        _createElementVNode("button", {
                          class: "g-button g-save",
                          disabled: !$setup.emailValid
                        }, "Create", 8, _hoisted_22)
                      ])
                    ], 32)
                  ])
                ]))
    ]),
    _: 1
  }, 8, ["click-to-close"]))
}